import { InputNumber } from './InputNumber';
export { InputNumber };
export type { InputNumberProps } from './InputNumber';
